/** fetch のレスポンスから SSE の data 行を読み出す。 */
export async function* readSSE(response: Response): AsyncGenerator<unknown> {
  if (!response.body) throw new Error('レスポンスの本文がありません');

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });

    // イベントは空行区切り
    let boundary = buffer.indexOf('\n\n');
    while (boundary !== -1) {
      const raw = buffer.slice(0, boundary);
      buffer = buffer.slice(boundary + 2);
      boundary = buffer.indexOf('\n\n');

      const dataLines = raw
        .split('\n')
        .filter((line) => line.startsWith('data:'))
        .map((line) => line.slice(5).trim());
      if (dataLines.length === 0) continue;

      try {
        yield JSON.parse(dataLines.join('\n'));
      } catch {
        // 壊れたイベントは黙って捨てる（次のイベントで復帰できる）
      }
    }
  }
}
